import { c as _c } from "react/compiler-runtime";
import { Checkboxes, Chips, DataStatus, Separator } from 'platform/components';
import { HStack, VStack } from 'platform/foundation-tw';
import { intersection } from 'ramda';
import { isArray } from 'ramda-adjunct';
import { Nullish, suffixTestId, useOnMount } from 'shared/web';
import { quickFiltersConst } from '../../constants/quickFilters';
import { useChoiceFilter } from '../../hooks/useChoiceFilter';
import { useFilterOnChipsChange } from '../../hooks/useFilterOnChipsChange';
import { useLazyChoiceFilterOptions } from '../../hooks/useLazyChoiceFilterOptions';
import { EagFilterProps } from '../../types/EagFilterProps';
export type CheckboxFilterProps = EagFilterProps & {
  columnKey: string;
  quickFilters?: Array<{
    value: string;
    label: string;
  }>;
};
const FILTER_VALUE_KEY = 'value';
export function CheckboxFilter(props) {
  const $ = _c(36);
  const rawModel = props.value[FILTER_VALUE_KEY] as string[] | string | Nullish;
  let t0;
  if ($[0] !== props) {
    t0 = newValue => {
      props.onChange({
        [FILTER_VALUE_KEY]: newValue
      });
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== rawModel || $[3] !== t0) {
    t1 = {
      model: rawModel,
      onChange: t0
    };
    $[2] = rawModel;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const [values, setValues] = useChoiceFilter(t1);
  let t2;
  if ($[5] !== props.columnKey) {
    t2 = {
      columnKey: props.columnKey
    };
    $[5] = props.columnKey;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    loadOptions,
    isLoading,
    options,
    errorMessage
  } = useLazyChoiceFilterOptions(t2);
  let t3;
  if ($[7] !== setValues) {
    t3 = {
      setFilterValue: setValues,
      defaultValue: null
    };
    $[7] = setValues;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    onChipsChange
  } = useFilterOnChipsChange(t3);
  let t4;
  if ($[9] !== values) {
    t4 = isArray(values) ? values : [values];
    $[9] = values;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = intersection(t4, quickFiltersConst);
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const isQuickFilterValue = t5;
  const isControlDisabled = props.isDisabled;
  let t6;
  if ($[13] !== loadOptions) {
    t6 = () => {
      loadOptions();
    };
    $[13] = loadOptions;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  useOnMount(t6);
  let t7;
  if ($[15] !== isQuickFilterValue || $[16] !== onChipsChange || $[17] !== props) {
    t7 = props.quickFilters && props.quickFilters.length > 0 && <><HStack><Chips isDisabled={props.isDisabled} value={isQuickFilterValue} options={props.quickFilters} onChange={onChipsChange} isMultiple={false} data-testid={suffixTestId("checkbox-filter-quickFilters", props)} isDeselectable={true} /></HStack><Separator /></>;
    $[15] = isQuickFilterValue;
    $[16] = onChipsChange;
    $[17] = props;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== values) {
    t8 = isArray(values) ? values : null;
    $[19] = values;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== props) {
    t9 = suffixTestId("checkbox-filter", props);
    $[21] = props;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== errorMessage || $[24] !== isControlDisabled || $[25] !== options || $[26] !== setValues || $[27] !== t8 || $[28] !== t9) {
    t10 = <Checkboxes options={options} value={t8} onChange={setValues} isDisabled={isControlDisabled} errorMessage={errorMessage} checkedIcon="navigation/check" data-testid={t9} />;
    $[23] = errorMessage;
    $[24] = isControlDisabled;
    $[25] = options;
    $[26] = setValues;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== isLoading || $[31] !== t10) {
    t11 = <DataStatus isLoading={isLoading}>{t10}</DataStatus>;
    $[30] = isLoading;
    $[31] = t10;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t11 || $[34] !== t7) {
    t12 = <VStack>{t7}{t11}</VStack>;
    $[33] = t11;
    $[34] = t7;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
}